module.exports = __webpack_public_path__ + "static/media/thwjs.f2a2a1b2.png";